 // import external dependencies
import 'jquery';
import 'slick-slider';

jQuery(document).ready(function() {
    //* Vars
    let elementsLoaded = 0;
    let totalElements = 3;
    
    //* Load main image
    $('.js-hero-backgrounds').each(function() {
        let bgRef = $(this);
        let imgUrl = bgRef.attr('data-image');
        if (bgRef.attr('data-key') == '0') {
            $('<img/>').attr('src', imgUrl).on('load', function() {
                $(this).remove();
                bgRef.css('background-image', 'url(' + imgUrl + ')');
                elementsLoaded++;
            });
        } else {
            bgRef.css('background-image', 'url(' + imgUrl + ')');
        }
    });

    //* Set breakpoints
    let screenSize;
    function calculateScreenSize() {
        let width = $(window).width();
        if (width < 768) {
            screenSize = 'mobile';
        } else if (width < 1024) {
            screenSize = 'tablet';
        } else {
            screenSize = 'desktop';
        }
    }
    calculateScreenSize();
    $(window).resize(calculateScreenSize);
    
    jQuery('.js-hero-slider').on('init', function() {
        elementsLoaded++;
    })
    
    jQuery('.js-hero-slider').slick({
        mobileFirst: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: true,
                    dotsClass: 'c-hero-slider-dots', 
                },
            },
        ],
    });

    jQuery('.js-product-slider').on('init', function() {        
        elementsLoaded++;
        let colorA, colorB;
        if (screenSize == 'mobile' || screenSize == 'tablet') {
            colorA = jQuery('.slick-current').find('.js-product-slider-color-a').attr('data-color');
            colorB = jQuery('.slick-current').find('.js-product-slider-color-b').attr('data-color');
        } else {
            colorA = jQuery('.slick-current').next().find('.js-product-slider-color-a').attr('data-color');
            colorB = jQuery('.slick-current').next().find('.js-product-slider-color-b').attr('data-color');
        }        
        
        jQuery('.js-product-slider-color-a-target').css({'background-color': colorA, 'fill': colorA, 'stroke': colorA});
        jQuery('.js-product-slider-color-b-target').css({'background-color': colorB, 'fill': colorB, 'stroke': colorB});
    });

    const productSlider = jQuery('.js-product-slider').slick({
        mobileFirst: true,
        prevArrow: '.js-slider-prev-arrow',
        nextArrow: '.js-slider-next-arrow',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
        ],
    });
    
    productSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        console.log(event, slick, currentSlide);        

        let slideIndex;
        if (screenSize == 'mobile' || screenSize == 'tablet') {
            slideIndex = nextSlide;
        } else {
            slideIndex = nextSlide + 1;
        }

        let colorA = jQuery('.slick-slide[data-slick-index="' + slideIndex + '"]').find('.js-product-slider-color-a').attr('data-color');
        let colorB = jQuery('.slick-slide[data-slick-index="' + slideIndex + '"]').find('.js-product-slider-color-b').attr('data-color');

        jQuery('.js-product-slider-color-a-target').css({'fill': colorA});
        jQuery('.js-product-slider-color-a-target').css({'stroke': colorA});
        jQuery('.js-product-slider-color-a-target').css({'background-color': colorA});        
        jQuery('.js-product-slider-color-b-target').css({'background-color': colorB, 'fill': colorB, 'stroke': colorB});

    });

    //* Social slider
    if (screenSize == 'mobile' || screenSize == 'tablet') { 
        totalElements = 4;

        jQuery('.js-social-slider').on('init', function() {
            elementsLoaded++;
        });

        jQuery('.js-social-slider').slick({ 
            arrows: false,
            dots: true,
            dotsClass: 'c-social-slider-dots', 
        });
    }

    var interval = setInterval(function() {
        if (elementsLoaded == totalElements) {
            $('.js-loader').css({'opacity': 0, 'visibility': 'hidden'});
            clearInterval(interval);
        }
    }, 300);

});


// WEBPACK FOOTER //
// ./scripts/main.js